export const TEXTS = {
  CONFIRM_OPERATION_MODAL_DEFAULT_TITLE: 'Подтверждение операции',
  CONFIRM_OPERATION_MODAL_DEFAULT_DESCRIPTION: 'Подтвердите операцию. Отменить текущее действие будет невозможно',
  CONFIRM_OPERATION_MODAL_SUBMIT_BUTTON_DEFAULT_TEXT: 'Подтвердить',
  CONFIRM_OPERATION_MODAL_CANCEL_BUTTON_DEFAULT_TEXT: 'Отменить',
};
